import styled from 'styled-components';

export const StyledBuildingDashboard = styled.div`
    font-family: var(--bllink-font-primary);

    .page-title {
        font-size: 26px;
        margin-bottom: 20px;
        padding: 0 30px;

        .building-address {
            font-size: 20px;
            color: var(--bllink-purple);
        }
    }

    .stats-wrapper {
        display: flex;
        gap: 26px;
        padding: 0 30px;
    }
`
